<template>
  <span style="vertical-align: middle">
    <span v-if="users.length > 0" style="display: inline-flex; flex-wrap: wrap">
      <span v-for="(user, index) in users" :key="index">
        <template v-if="!user.id">
          <span v-if="avatar" class="user-item">
            <a-avatar :src="user.avatar_url" :size="22" />
            <span class="nickname">{{ user.nickname }}</span>
          </span>
          <a v-else class="custom-link">{{ user.nickname }}</a>
        </template>
        <a-popover v-else overlay-class-name="user-profile-popover" placement="rightTop" trigger="click" :destroy-tooltip-on-hide="true">
          <div slot="content" style="width: 672px">
            <a-row>
              <a-col :span="8">
                <feishu-user-profile :key="user.open_id" :open-id="user.open_id" />
              </a-col>
              <a-col :span="16">
                <user-work-info style="padding: 8px" :user-id="user.id" />
              </a-col>
            </a-row>
          </div>
          <span v-if="avatar" class="user-item">
            <a-avatar :src="user.avatar_url" :size="22" />
            <span class="nickname">{{ user.nickname }}</span>
          </span>
          <a v-else class="custom-link">{{ user.nickname }}</a>
        </a-popover>
      </span>
    </span>
    <span v-else>--</span>
  </span>
</template>
<script>
import UserWorkInfo from '@/components/User/WorkInfo.vue';
import FeishuUserProfile from '@/components/FeiShu/UserProfile';

export default {
  name: 'UserProfiles',
  install(Vue) {
    Vue.component('UserProfiles', this);
  },
  components: { UserWorkInfo, FeishuUserProfile },
  props: {
    value: {
      type: [Array, Number],
      default: () => {
        return [];
      }
    },
    avatar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userMap: {
        0: {
          id: 0,
          nickname: '系统',
          avatar_url: 'https://devops-resource.cdfsunrise.com/other/202205161957391065.png'
        }
      }
    };
  },
  computed: {
    users() {
      const users = this.value.map(item => {
        return this.userMap[item];
      });
      return users;
    }
  },
  created() {
    this.$store.state.allUsers.map(item => {
      this.userMap[item.id] = item;
    });
  }
};
</script>

<style lang="less" scoped>
.user-item {
  border-radius: 22px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 0px;
  color: #1f2329;
  background: linear-gradient(90deg, #f5f8ff 60%, #eaf0ff 100%);
  box-shadow: 0 1px 4px rgba(80, 120, 255, 0.06);
  border: 1px solid transparent;
  transition: background 0.2s, box-shadow 0.2s, border 0.2s;
  max-width: 100px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;

  .nickname {
    margin: 0 0.25em;
    line-height: 22px;
    font-size: 14px;
    color: #2d3a4a;
    max-width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    letter-spacing: 0.01em;
  }
}
.user-item:hover {
  background: linear-gradient(90deg, #eaf0ff 60%, #d2ddfc 100%);
  box-shadow: 0 2px 8px rgba(80, 120, 255, 0.13);
  border: 1px solid #6b8cff;
}
</style>
<style>
.user-profile-popover .ant-popover-inner-content {
  padding: 0px !important;
}
.user-profile-popover .ant-popover-inner {
  border-radius: 12px !important;
}
</style>
